import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { Sprite } from "pixi.js";
export class TitanGraphics extends TitanSprite {
    static createSprite(parent, name, properties, portraitProperties, landscapeTexture, portraitTexture) {
        let sprite;
        sprite = new TitanGraphics(properties, portraitProperties, landscapeTexture, portraitTexture);
        if (name) {
            sprite.name = name;
        }
        if (sprite && parent) {
            parent.addChild(sprite);
        }
        return sprite;
    }
    constructor(properties, portraitProperties, landscapeTexture, portraitTexture) {
        super(properties, portraitProperties);
        this.landscapeTexture = landscapeTexture;
        this.portraitTexture = portraitTexture;
        this.run();
    }
    run() {
        if (!this.landscapeTexture || !this.portraitTexture) {
            return;
        }
        else {
            super.run();
        }
    }
    createSprites() {
        if (this.landscapeTexture) {
            this.landscapeSprite = new Sprite(this.landscapeTexture);
            this.landscapeSprite.renderable = this.renderer.isLandscape() || !this.hasPortraitProperties;
            this.addChild(this.landscapeSprite);
        }
        if (this.portraitTexture) {
            this.portraitSprite = new Sprite(this.portraitTexture);
            this.portraitSprite.renderable = this.renderer.isPortrait();
            this.responsive = true;
            this.addChild(this.portraitSprite);
        }
    }
}
export class GraphicsProperties extends SpriteProperties {
    constructor(position, scale, anchor, rotation) {
        super(null, null, position, scale, anchor, rotation);
    }
}
//# sourceMappingURL=TitanGraphics.js.map